module.exports = __webpack_public_path__ + "img/16.be280afd.jpg";